if (!window.theme._registeredSections['featured-blocks'] === true) {
  theme.featuredBlocks = (function () {
    // Function to kick in Slick slider for mobile
    //  on featured collection product cards.

    // Note: .not('slick-initialized') is to stop
    //  double firing on initialize when resizing.

    function featuredBlocks() {
    }

    return featuredBlocks;
  })();

  window.theme.sections.register('featured-blocks', theme.featuredBlocks);
  window.theme._registeredSections['featured-blocks'] = true;
}
